export const types = {
    NEW: 'NEW-FOLDER',
    DELETE: 'DELETE',
    COPY: 'COPY',
    ZIP: 'ZIP',
    MOVE: 'MOVE',
    RENAME: "RENAME",
    UNZIP: "UNZIP",
    GETFILESINFOLDER: "GET-FILES-IN-FOLDER",
    GETPROPERTIES: "GET-PROPERTIES"
};